<template>
  <v-text-field
    type="number"
    v-bind="$attrs"
    v-model="model"
    class="p-number-input"
    @keydown="onKeydown"
  ></v-text-field>
</template>


<script>
export default {
  inheritAttrs: false,


  props: {
    value: {
      type: Number
    },
    integer: {
      type: Boolean,
      default: false
    }
  },


  computed: {
    model: {
      get () {
        return this.value
      },
      set (val) {
        const number = this.parseNumber(val)
        this.$emit('input', number)
      }
    }
  },


  methods: {
    parseNumber (val) {
      let number = null

      if (val !== null && val.trim() !== '') {
        number = this.integer ? parseInt(val) : parseFloat(val)
      }

      return number
    },

    onKeydown (event) {
      if (this.integer === true) {
        if (event.key === '.' || event.key === ',') {
          event.preventDefault()
        }
      }
    }
  }
}
</script>
